/* @flow */
/* eslint no-unused-vars: 0 */

import React from "react"

class ProductAggregateOption extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { checked, unchecked } = this.props.assets.icons;

    const aggregate_status =
      this.props.option.selected === true ? (
        <img src={checked} alt="" height={20} width={20} />
      ) : (
        <img src={unchecked} alt="" height={20} width={20} />
      );

    if (this.props.option.key === '') {
      return null;
    } else {
      return (
        <li
          onClick={() => {
            this.props.toggleAggregate(
              this.props.agg_type.toLowerCase(),
              this.props.option.value,
              true,
              true
            );
          }}
        >
          {aggregate_status}
          {this.props.option.key}
          <span className="aggregate--count">
            ({this.props.option.doc_count})
          </span>
        </li>
      );
    }
  }
}

export default ProductAggregateOption;
